import React from 'react'
import { Platform, StyleSheet, View, ViewProps } from 'react-native'

import { Color } from '../../style'
import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    height: 20,
    minWidth: 20,
    borderRadius: 10,
    backgroundColor: Color.calmGrey,
    paddingHorizontal: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 12,
  },
})

const defaultColorConfig = {
  default: StyleSheet.create({
    container: {
      backgroundColor: Color.darkGreyBlue,
    },
    title: {
      color: Color.simplyWhite,
    },
  }),
  error: StyleSheet.create({
    container: {
      backgroundColor: Color.darkRed,
    },
    title: {
      color: Color.simplyWhite,
    },
  }),
  warning: StyleSheet.create({
    container: {
      backgroundColor: Color.collCopper,
    },
    title: {
      color: Color.simplyWhite,
    },
  }),
  success: StyleSheet.create({
    container: {
      backgroundColor: Color.refinedGreen,
    },
    title: {
      color: Color.simplyWhite,
    },
  }),
  inactive: StyleSheet.create({
    container: {
      backgroundColor: Color.metalGrey,
    },
    title: {
      color: Color.simplyWhite,
    },
  }),
}

const lightColorConfig = {
  default: StyleSheet.create({
    container: {
      backgroundColor: Color.lightGreyBlue,
    },
    title: {
      color: Color.darkGreyBlue,
    },
  }),
  error: StyleSheet.create({
    container: {
      backgroundColor: Color.soothingPink,
    },
    title: {
      color: Color.darkRed,
    },
  }),
  warning: StyleSheet.create({
    container: {
      backgroundColor: Color.collCopper,
    },
    title: {
      color: Color.coffee,
    },
  }),
  success: StyleSheet.create({
    container: {
      backgroundColor: Color.lightRefinedGreen,
    },
    title: {
      color: Color.darkRefinedGreen,
    },
  }),
  /*eslint-disable react-native/no-unused-styles */
  inactive: StyleSheet.create({
    container: {
      backgroundColor: Color.calmGrey,
    },
    title: {
      color: Color.metalGrey,
    },
  }),
  /*eslint-enable react-native/no-unused-styles */
}

export type BadgeStatus = keyof typeof defaultColorConfig
export const BadgeStatuses = Object.keys(defaultColorConfig) as BadgeStatus[]

export interface Props extends ViewProps {
  title?: string
  status?: BadgeStatus
  light?: boolean
}
const Badge = (props: Props) => {
  const { style, title, status, light, ...otherProps } = props

  const statusConfig = (light ? lightColorConfig : defaultColorConfig)[(status as BadgeStatus) || 'default']
  const containerStyle = [styles.container, statusConfig.container, style]
  const titleStyle = [styles.title, statusConfig.title, { lineHeight: Platform.OS === 'android' ? 12 : undefined }]

  return (
    <View style={containerStyle} {...otherProps}>
      <Text level={5} style={titleStyle}>
        {title}
      </Text>
    </View>
  )
}

export default Badge
